<template>
  <div class="wrap">
    <h1 class="drug-tit">药品投诉监管<span class="chart-modal-flag" @click="dialogVisible = true"><i class="el-icon-view"></i></span></h1>
    <div class="drug-con">
      <div class='drug-con-tit'>
        <span>消费者投诉</span>
        <span>投诉药品</span>
        <span>投诉地域</span>
      </div>
      <div class="drug-table">
        <div class='complaint-l fl'>
          <span class="complaint-l-all">全国投诉</span>
          <em style="font-size:60px; font-weight:700;letter-spacing: -7px;">{{number|filterNumber}}</em> <br/>
          月度: <span>21.5%</span>
          <div class="down-png-box">
            <span class="down-png"></span>
          </div>

        </div>
        <ul class="complaint-r fr">
          <li
            class="complaint-item"
            v-for="item in rotateVal"
          >
            <span>{{item.name}}</span>
            <span>{{item.area}}</span>
          </li>
        </ul>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true" :fullscreen="true" center :modal="mask">
      <img style="width: 100%;height: 100%;" src="../../../static/imgs/complaintSupervision.jpg" alt="">
    </el-dialog>
  </div>
</template>
<script>
import { vueBus } from '../../assets/js/common/vueBus'
import { TimelineMax, Back, TweenMax, CustomEase } from 'gsap'
export default {
  data() {
    return {
      dialogVisible: false,
      mask: false,
      fullscreen: true,
      number: 0,
      anima: '',
      idx: 0,
      count: 1,
      rotateVal: [
        {
          name: '左氧氟沙星注射液',
          area: '山西'
        },
        {
          name: '注射用头孢曲松',
          area: '辽宁'
        },
        {
          name: '清开灵注射液',
          area: '福建'
        },
        {
          name: '注射用阿糖胞苷',
          area: '云南'
        }
      ],
      complaints: [
        {
          name: '红花注射液',
          area: '四川'
        },
        {
          name: '盐酸二甲双胍片',
          area: '宁夏'
        },
        {
          name: '肠溶阿司匹林片',
          area: '福建'
        },
        {
          name: '注射用乳糖酸阿奇霉素',
          area: '辽宁'
        },
        {
          name: '麻黄饮片',
          area: '湖北'
        },
        {
          name: '注射用辅酶',
          area: '安徽'
        },
        {
          name: '卡托普利片',
          area: '海南'
        },
        {
          name: '氧氟沙星滴眼液',
          area: '陕西'
        },
        {
          name: '杜仲平压片',
          area: '贵州'
        },
        {
          name: '复方穿心莲片',
          area: '云南'
        },
        {
          name: '左氧氟沙星注射液',
          area: '山西'
        },
        {
          name: '注射用头孢曲松',
          area: '辽宁'
        },
        {
          name: '清开灵注射液',
          area: '福建'
        },
        {
          name: '注射用阿糖胞苷',
          area: '云南'
        }
      ]
    }
  },
  mounted() {
    let me = this
    var tm2 = new TimelineMax()
    tm2.to('.down-png', 1.8, {
      top: 36,
      repeat: -1
    })
    vueBus.$on('imgOnload', v => {
      me.anima = v
    })
  },
  watch: {
    anima(val, oldVal) {
      val == 'animateStart' && this.animate()
    }
  },
  methods: {
    handleClose(done) {
      done();
    },
    animate() {
      let me = this
      TweenMax.to(this, 2, { number: 5121 })
      var tm1 = new TimelineMax()
      tm1.staggerFrom(
        '.complaint-item',
        1,
        { rotationX: 180, opacity: 0, repeatDelay: 6, repeat: -1, onRepeat: me.animUpdate },
        0.2
      )

      var start = +new Date()
      setInterval(function() {
        var end = +new Date()
        if (end - start >= 36000000) {
          start = end
          TweenMax.to(me, 1, { number: 5121 })
        } else {
          var val = Math.floor(Math.random() * 2) + 5
          TweenMax.to(me, 2, { number: me.number + val })
        }
      }, 4000)
    },
    animUpdate() {
      this.count++
      if (this.count == 4) {
        this.count = 0
        this.idx = this.idx + 4
        if (this.idx >= 12) {
          this.idx = 0
        }
        this.rotateVal = [
          this.complaints[this.idx],
          this.complaints[this.idx + 1],
          this.complaints[this.idx + 2],
          this.complaints[this.idx + 3]
        ]
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;
  .drug-tit {
    height: 76px;
    line-height: 95px;
    font-size: 40px;
    font-weight: 700;
    color: #65ecc3;
    text-align: center;
    letter-spacing: 2px;
  }
  .el-dialog__body{
  height: 100%;
  width: 100%;
  .drug-con {
    height: 100%;
    font-size: 26px;
    // padding: 35px 30px 35px;
    // box-sizing: border-box;
    // letter-spacing: 2px;
    background: url("../../../static/imgs/chart-bg.png") no-repeat;
    background-size:cover;
  }
}
  
  .drug-con-tit {
    height: 80px;
    line-height: 80px;
    border: 2px solid #08a7df;
    span {
      display: inline-block;
      text-align: center;
      color: #65ecc3;
      font-size: 30px;
      font-weight: bold;
      &:nth-child(1) {
        width: 300px;
      }
      &:nth-child(2) {
        width: 250px;
      }
      &:nth-child(3) {
        width: 240px;
      }
    }
  }
  .drug-table {
    width: 808px;
    height: 200px;
    margin: 20px auto 0;
    .complaint-l {
      width: 302.5px;
      text-align: center;
      line-height: 56px;
      position: relative;
      font-size: 32px;
      .complaint-l-all {
        display: block;
        margin-bottom: 10px;
      }
      .down-png-box {
        width: 28px;
        height: 36px;
        position: absolute;
        bottom: 10px;
        right: 24px;
        overflow: hidden;
      }
      .down-png {
        width: 28px;
        height: 36px;
        position: absolute;
        background: url('../../assets/imgs/down-png.png') center no-repeat;
        background-size: cover;
        top: -36px;
        left: 0;
      }
    }
    .complaint-r {
      perspective: 400px;
      perspective-origin: 0% 50%;
      .complaint-item {
        width: 492px;
        height: 46px;
        line-height: 46px;
        margin-bottom: 3px;
        transform-origin: 50% 50%;
        span {
          text-align: center;
          display: inline-block;
          line-height: 46px;
          height: 46px;
          &:nth-child(1) {
            width: 280px;
          }
          &:nth-child(2) {
            width: 200px;
          }
        }
        &:nth-child(2n) {
          background: #ffffff4f;
        }
        &:nth-child(2n-1) {
          background: #1f6b7f94;
        }
      }
    }
  }
}
.chart-modal-flag {
  line-height: 64px;
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  right: 25px;
  position: absolute;
  i {
    color: #fff;
    cursor: pointer;
    font-weight: 900;
  }
}

.chart-top-title {
  height: 76px;
  line-height: 95px;
  font-size: 40px;
  font-weight: 700;
  color: #65ecc3;
  text-align: center;
  letter-spacing: 2px;
  position: relative;
  .chart-select {
    position: absolute;
    width: 175px;
    height: 45px;
    line-height: 45px;
    border: 2px solid #046292;
    left: 28px;
    top: 26px;
    border-radius: 8px;
    font-weight: 400;
    color: #fff;
    font-size: 20px;
    text-align: left;
    padding-left: 20px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
  }
  .select-icon {
    position: absolute;
    font-size: 26px;
    right: 10px;
    top: 3px;
  }
 }
 .remarkes {
  height: 40px;
  line-height: 24px;
  font-size: 20px;
  color: #acb4bc;
  padding-left: 50px;
}

</style>




// WEBPACK FOOTER //
// src/components/drugComplaint/drugComplaint.vue